import * as actionTypes from "./ActionTypes"
import { APIGet, APIPost } from "services/APIRequest"
import UrlServer from "configs/UrlServer"

export const listsProjectUpdate = () => {
  return dispatch => {
    APIGet(UrlServer.URL_GET_PROJECT_ADMIN, datas => {
      dispatch({ type: actionTypes.LISTS_PROJECT_UPDATE, listsProject: datas.datas })
    })
  }
}
